<label class="h4">
    <span *ngIf="ngDisabled"><i class="fa fa-file-pdf-o fa-fw danger"></i></span>
    <span *ngIf="!ngDisabled"><i class="fa fa-refresh fa-spin fa-fw"></i></span> 
    Export PDF:
    &nbsp;

    <a ng-mouseenter="tooltip['download'] = true;" ng-mouseleave="tooltip['download'] = false;" ng-class="{ 'disabled': ngDisabled, 'cursor-pointer': !ngDisabled }">
        <i class="fa fa-download fa-fw" uib-tooltip-html="'Download PDF'" tooltip-trigger="'none'" tooltip-is-open="tooltip['download']" tooltip-placement="top auto" (click)="exportPdf()"></i>
    </a>
    &nbsp;&nbsp;
    <a ng-mouseenter="tooltip['open'] = true;" ng-mouseleave="tooltip['open'] = false;" ng-class="{ 'disabled': ngDisabled, 'cursor-pointer': !ngDisabled }">
        <i class="fa fa-external-link fa-fw" uib-tooltip-html="'Open PDF'" tooltip-trigger="'none'" tooltip-is-open="tooltip['open']" tooltip-placement="bottom auto" (click)="exportPdf('open')"></i>
    </a>
</label>